module.exports = __webpack_public_path__ + "static/img/m_role.df1e9ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/bz/m_role.png
// module id = WdPm
// module chunks = 7